import { Field, Form, Formik } from "formik";
import _ from 'lodash';
import moment from 'moment';
import "moment-timezone";
import React, { useEffect, useState } from "react";
import { Alert as BSAlert, Button, ControlLabel } from "react-bootstrap";
import { useHistory, useParams } from "react-router";
import { Link } from 'react-router-dom';
import Alert from "react-s-alert";
import shortid from "shortid";
import * as Yup from "yup";
import FormikFormControl from "../../Shared/Forms/FormikFormControl";
import UsersService from "../../utils/UsersService";
import { formats } from '../../variables/variables';
import AddAvailabilityException from "./schedule/AddAvailabilityException";
import AddMultiWeekPattern from "./schedule/AddMultiWeekPattern";
import AddTimeOffPeriod from "./schedule/AddTimeOffPeriod";
import AvailabilityExceptions from "./schedule/AvailabilityExceptions";
import EditRegularAvailability from './schedule/EditRegularAvailability';
import MultiWeekPatterns from "./schedule/MultiWeekPatterns";
import RegularAvailability from "./schedule/RegularAvailability";
import ScheduleView from "./ScheduleView";
import TimeOffPeriods from "./schedule/TimeOffPeriods";

const UserSchedule = () => {
  const history = useHistory();
  const { id } = useParams()
  const [user, setUser] = useState();
  const [availabilityExceptions, setAvailabilityExceptions] = useState([]);
  const [regularAvailability, setRegularAvailability] = useState({});
  const [regularAvailabilityPatterns, setRegularAvailabilityPatterns] = useState([]);
  const [timeOffPeriods, setTimeOffPeriods] = useState([]);
  const [editRegularHours, setEditRegularHours] = useState(false);
  const [addPattern, setAddPattern] = useState(false);
  const [addTimeOff, setAddTimeOff] = useState(false);
  const [dirty, setDirty] = useState(false);

  const sortAEXs = (aexs) => {
    const newAexs = aexs.sort((a, b) => {
      const d1 = moment(a.date, formats.consistentDateFormat)
      const d2 = moment(b.date, formats.consistentDateFormat)
      return d1.isAfter(d2) ? 1 : -1
    })
    return newAexs;
  }

  const sortPatterns = (patterns) => patterns.sort((a, b) => {
    const d1 = moment(a.starts_on, formats.consistentDateFormat)
    const d2 = moment(b.starts_on, formats.consistentDateFormat)
    return d1.isAfter(d2) ? 1 : -1
  })

  const sortTimeOff = (periods) => periods.sort((a, b) => {
    const d1 = moment(a.starts_on, formats.consistentDateFormat)
    const d2 = moment(b.starts_on, formats.consistentDateFormat)
    return d1.isAfter(d2) ? 1 : -1
  })

  const getSchedule = () => {
    UsersService.get(id).then((data) => {
      setUser(data);
      setRegularAvailability(data.availability_schedule.regular_availability);
      setAvailabilityExceptions(
        sortAEXs(
          data.availability_schedule.availability_exceptions.map((aex) => {
            aex.id = shortid.generate();
            return aex;
          })
        )
      );
      setRegularAvailabilityPatterns(
        sortPatterns(
          (data.availability_schedule.regular_availability_patterns || []).map((pattern) => {
            pattern.id = shortid.generate();
            return pattern;
          })
        )
      );
      setTimeOffPeriods(
        sortTimeOff(
          (data.availability_schedule.time_off_periods || []).map((period) => {
            period.id = shortid.generate();
            return period;
          })
        )
      );
    });
  }
  useEffect(() => {
    getSchedule()
  }, [id])

  const validationSchema = Yup.object().shape({
    admin_notes: Yup.string().max(1000, "maximum 1000 characters"),
    tcs_work_hours: Yup.string().max(100, "maximum 100 characters"),
  });

  if (!user || !regularAvailability || !availabilityExceptions || !regularAvailabilityPatterns || !timeOffPeriods) return null;

  const removeAEX = (index) => {
    const newAEXs = [...availabilityExceptions];
    newAEXs.splice(index, 1);
    setAvailabilityExceptions(sortAEXs(newAEXs));
    setDirty(true);
  };

  const addAEX = (aex) => {
    if (availabilityExceptions.find((a) => a.date === aex.date && a.date_to === aex.date_to && _.isEqual(a.available, aex.available))) return
    const newAEXs = [...availabilityExceptions];
    newAEXs.push(aex);
    setAvailabilityExceptions(sortAEXs(newAEXs));
    setDirty(true);
  };

  const removePattern = (index) => {
    const newPatterns = [...regularAvailabilityPatterns];
    newPatterns.splice(index, 1);
    setRegularAvailabilityPatterns(sortPatterns(newPatterns));
    setDirty(true);
  };

  const addPatternToSchedule = (pattern) => {
    setRegularAvailabilityPatterns(sortPatterns([...regularAvailabilityPatterns, pattern]));
    setAddPattern(false);
    setDirty(true);
  };

  const removeTimeOff = (index) => {
    const newPeriods = [...timeOffPeriods];
    newPeriods.splice(index, 1);
    setTimeOffPeriods(sortTimeOff(newPeriods));
    setDirty(true);
  };

  const addTimeOffToSchedule = (period) => {
    setTimeOffPeriods(sortTimeOff([...timeOffPeriods, period]));
    setAddTimeOff(false);
    setDirty(true);
  };

  const updateRegularAvailability = (values) => {
    setRegularAvailability(values)
    setEditRegularHours(false)
    setDirty(true)
  }
  const cancelEditRegularAvailability = () => setEditRegularHours(false)

  return (
    <>
      <h3 className="first-title mt-0 mb-3">
        <Link to={`/m1/users`}>Users</Link><i className='fal fa-caret-right' style={{marginLeft:10, marginRight: 10}}></i>
        Schedule for {user.first_name} {user.last_name}{" "}
        <span style={{ fontSize: 18 }}>&lt;{user.email}&gt;</span>
        <small style={{ marginLeft: 40 }}>
          <Link to={`/m1/users/${user.id}`}>edit user info</Link>
        </small>
      </h3>
      <Formik
        initialValues={{
          options: user.options || { tcs_priority: 3 },
          schedule_time_zone:
            user.availability_schedule.time_zone || "Australia/Melbourne",
        }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);
          values.availability_schedule = {
            availability_exceptions: availabilityExceptions,
            regular_availability: regularAvailability,
            regular_availability_patterns: regularAvailabilityPatterns,
            time_off_periods: timeOffPeriods,
          };
          UsersService.update(id, values).then((data) => {
            Alert.success("Updated user schedule");
            getSchedule();
            setDirty(false);
          });
          setSubmitting(false);
        }}
        render={({
          errors,
          touched,
          isValid,
          isSubmitting,
          values,
          setFieldValue,
          setFieldTouched,
        }) => (
          <div style={{ display: "flex" }}>
            {editRegularHours ? (
              <>
                <EditRegularAvailability
                  regularAvailability={regularAvailability}
                  update={updateRegularAvailability}
                  cancel={cancelEditRegularAvailability}
                />
              </>
            ) : addPattern ? (
              <AddMultiWeekPattern
                add={addPatternToSchedule}
                cancel={() => setAddPattern(false)}
              />
            ) : addTimeOff ? (
              <AddTimeOffPeriod
                add={addTimeOffToSchedule}
                cancel={() => setAddTimeOff(false)}
              />
            ) : (
              <Form>
                <div style={{ display: "flex" }}>
                  <div className="form-group">
                    <label>TCS Priority</label>
                    <div style={{ width: 225, marginRight: 20 }}>
                      <select
                        value={values.options.tcs_priority}
                        name="tcs_priority"
                        className="form-control"
                        onChange={(e) => {
                          const vals = values.options;
                          vals.tcs_priority =
                            e.target.value === ""
                              ? null
                              : parseInt(e.target.value);
                          setFieldValue("options", vals);
                        }}
                      >
                        <option value="">No priority</option>
                        <option value={1}>Very High</option>
                        <option value={2}>High</option>
                        <option value={3}>Medium</option>
                        <option value={4}>Low</option>
                        <option value={5}>Very Low</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Schedule Hours In Time Zone</label>
                    <div style={{ width: 225, marginRight: 20 }}>
                      <select
                        value={values.schedule_time_zone}
                        name="schedule_time_zone"
                        className="form-control"
                        onChange={(e) => {
                          setFieldValue("schedule_time_zone", e.target.value);
                        }}
                      >
                        <option value="Australia/Melbourne">Melbourne</option>
                        <option value="Australia/Sydney">Sydney</option>
                        <option value="Australia/Perth">Perth</option>
                        <option value="Australia/Brisbane">Brisbane</option>
                        <option value="Australia/Canberra">Canberra</option>
                        <option value="Australia/Adelaide">Adelaide</option>
                        <option value="Australia/Hobart">Hobart</option>
                        <option value="Australia/Darwin">Darwin</option>
                      </select>
                    </div>
                  </div>

                  <FormikFormControl
                    fieldName="tcs_work_hours"
                    errors={errors}
                    touched={touched}
                    style={{ marginRight: 20, width: 400 }}
                  >
                    <ControlLabel>
                      TCS Hints <small>(shown in Assign)</small>
                    </ControlLabel>
                    <Field
                      type="text"
                      name="options.tcs_work_hours"
                      className="form-control"
                      onChange={(e) => {
                        const vals = values.options;
                        vals.tcs_work_hours = e.target.value;
                        setFieldValue("options", vals);
                      }}
                    />
                  </FormikFormControl>
                </div>

                <div style={{ display: "flex" }}>
                  <RegularAvailability
                    setEditMode={(val) => setEditRegularHours(val)}
                    style={{ marginRight: 20 }}
                    regularAvailability={regularAvailability}
                  />
                  <AvailabilityExceptions
                    style={{ marginRight: 20 }}
                    availabilityExceptions={availabilityExceptions}
                    remove={removeAEX}
                  />
                </div>

                <MultiWeekPatterns
                  style={{ marginRight: 20 }}
                  patterns={regularAvailabilityPatterns}
                  remove={removePattern}
                  setAddMode={(val) => setAddPattern(val)}
                />

                <TimeOffPeriods
                  style={{ marginRight: 20 }}
                  periods={timeOffPeriods}
                  remove={removeTimeOff}
                  setAddMode={(val) => setAddTimeOff(val)}
                />

                <div>
                  {dirty && (
                    <p className="text-warning">
                      Unsaved changes have been made to the schedule, ensure
                      changes are saved before leaving page
                    </p>
                  )}
                  <div>
                    <Button
                      onClick={() => history.push("/m1/users")}
                      bsSize="small"
                      className="mr-2"
                    >
                      Cancel Changes
                    </Button>
                    <Button
                      disabled={isSubmitting}
                      type="submit"
                      bsStyle={dirty ? "warning" : "info"}
                      bsSize="small"
                    >
                      Update Schedule with Changes
                    </Button>
                  </div>
                </div>
              </Form>
            )}

            {!editRegularHours && !addPattern && !addTimeOff && (
              <div
                style={{
                  background: "#f6f6f6",
                  border: "1px solid #ccc",
                  padding: "0 10px",
                }}
              >
                <AddAvailabilityException add={addAEX} />
              </div>
            )}
          </div>
        )}
      />

      {(editRegularHours || addPattern || addTimeOff) ? null : dirty ? (
        <BSAlert variant="info" style={{ margin: 50 }}>
          Changes need to be saved to update Calendar
        </BSAlert>
      ) : (
        <>
          <h4
            style={{
              marginTop: 50,
              paddingBottom: 10,
              borderBottom: "1px solid #ccc",
            }}
          >
            CALENDAR
          </h4>
          <ScheduleView singleUser={user} />
        </>
      )}
    </>
  );
};

export default UserSchedule;
